import {
	resetPersonDetail,
	selectPerson,
	selectPersonError,
	selectPersonLoader,
	TUpdateOrderType,
} from 'entities/person';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { ModalCard } from 'shared/ui/cards/modalCard';
import { PersonModalHeader } from './personModalHeader';
import { FC, useEffect, useRef, useState } from 'react';
import {
	getOrdersByPerson,
	resetOrderDetail,
	selectOrderBookingData,
} from 'entities/orders';
import { useEscapeById, useModal } from 'shared/lib/modal';
import { withPreloader } from 'shared/ui/spinner';
import { PersonModalCardContent } from './personModalCardContent';
import { OrderDashboard } from 'widgets/orderDashboard';
import { ModalProvider } from 'shared/ui/modal';
import { selectSettingDefaultPerson } from 'entities/settings';
import { Typography } from 'shared/ui/typography';

interface PersonModalCardProps {
	hideBookingBtn?: boolean;
	resetPersonAfterClose?: boolean;
	onBooking?: () => void;
	showOrderEdit?: boolean;
	updatePersonBook?: boolean;
	updateOrder?: TUpdateOrderType;
}

export const PersonModalCard: FC<PersonModalCardProps> = ({
	hideBookingBtn = false,
	resetPersonAfterClose = true,
	onBooking,
	showOrderEdit = true,
	updatePersonBook = false,
	updateOrder,
}) => {
  const PersonModalContent = withPreloader(PersonModalCardContent);

	const person = useAppSelector(selectPerson);
	const defaultPerson = useAppSelector(selectSettingDefaultPerson);
	const isLoading = useAppSelector(selectPersonLoader);
	const personError = useAppSelector(selectPersonError);
	const bookingData = useAppSelector(selectOrderBookingData);

	const dispatch = useAppDispatch();
	const { closeModal } = useModal();
	const [bookingIsOpen, setBookingOpen] = useState(false);

	const personModalCardIsLoaded = useRef(false);

	useEffect(() => {
		if (person && !personModalCardIsLoaded.current) {
			dispatch(
				getOrdersByPerson({
					person: person.id,
					ordering: '-dt_start',
				}),
			);

			personModalCardIsLoaded.current = true;
		}
	}, [person, dispatch, personModalCardIsLoaded]);

	useEffect(() => {
		if (bookingData.dt_start) {
			setBookingOpen(true);
		} else if (bookingIsOpen) {
			closeModal();
			setBookingOpen(false);
		}
	}, [bookingData, bookingIsOpen, closeModal]);

	const onCloseModal = () => {
		closeModal();
		if (resetPersonAfterClose) {
			dispatch(resetPersonDetail());
		}
		dispatch(resetOrderDetail());
	};

	const bookingHanlder = async () => {
		onBooking?.();
		closeModal();
	};

  const clearAllExceptPerson = async () =>{
    await dispatch(resetOrderDetail())
  }

	useEscapeById('person-modal', 'person-edit-modal')

	if (!person) {
		return null;
	}

	if (person?.id === defaultPerson) {
		return (
			<ModalCard
				onClose={onCloseModal}
				styles={{ cardVariant: 'default' }}
			>
				<Typography mode="h3" textAlignCenter style={{ paddingBottom: '32px' }}>Данные этого гостя нельзя отредактировать</Typography>
			</ModalCard>
		)
	}


	return (
		<ModalCard
			headerContent={
				<PersonModalHeader
					person={person}
					updatePersonBook={updatePersonBook}
					updateOrder={updateOrder}
				/>
			}
			styles={{ width: '828px' }}
			indentsCard={false}
			onClose={onCloseModal}
			scrollable
			id="person-modal"
		>
			<ModalProvider>
				<OrderDashboard
					marginLeft={false}
					includeOrderDetailButtons={false}
					includeCloseButtonInOrderDetail={false}
					includeContactInfo={false}
					maxHeightOrderDetail={''}
          heightPanel={'100%'}
					placeholder="Нажмите на визит который вас интересует,
						чтобы вы смогли увидеть полную информацию"
					softDesign={true}
					includePenButtonInOrderDetail={showOrderEdit}
          isModal={true}
          isOnlyInfo={!showOrderEdit&&onBooking ? true : false}
				>
					<PersonModalContent
						isLoading={isLoading}
						person={person}
						onCloseModal={onCloseModal}
						onBooking={onBooking && bookingHanlder}
            clearAllExceptPerson={clearAllExceptPerson}
						error={personError}
						hideBookingBtn={hideBookingBtn}
						showOrderEdit={showOrderEdit}
					/>
				</OrderDashboard>
			</ModalProvider>
		</ModalCard>
	);
};
